// ======================================================================
// File: indentService.js
// Module: PPE → Procurement → Indent
// ======================================================================

import axiosClient from "../../../../../../api/axiosClient";

const BASE_URL = "/api/ppe/material-flow/indent";

/**
 * ----------------------------------------------------------------------
 * LIST INDENTS
 * GET /api/ppe/material-flow/indent/list
 * ----------------------------------------------------------------------
 */
// ----------------------------------------------------------------------
// PAYLOAD NORMALIZER (CRITICAL FIX)
// ----------------------------------------------------------------------
function normalizeIndentPayload(payload) {
  return {
    ...payload,

    // REQUIRED ENUMS (prevents NULL)
    indent_type: payload.indent_type || "PRODUCTION",
    indent_source: payload.indent_source || "MANUAL",

    // REQUIRED DATE
    indent_date:
      payload.indent_date ||
      new Date().toISOString().split("T")[0],
  };
}


async function getIndentList(params = {}) {
  const res = await axiosClient.get(
    `${BASE_URL}/list`,
    { params }
  );

  return {
    items: res.data?.data || [],
    total: res.data?.data?.length || 0,
    page: params.page || 1,
    page_size: params.page_size || 10,
  };
}

/**
 * ----------------------------------------------------------------------
 * GET INDENT BY ID
 * ----------------------------------------------------------------------
 */
async function getIndentById(indentId) {
  const res = await axiosClient.get(
    `${BASE_URL}/${indentId}`
  );
  return res.data?.data;
}

/**
 * ----------------------------------------------------------------------
 * CREATE INDENT
 * POST /api/ppe/material-flow/indent/create
 * ----------------------------------------------------------------------
 */
async function createIndent(payload) {
  const res = await axiosClient.post(
    `${BASE_URL}/create`,
    normalizeIndentPayload(payload)
  );
  return res.data?.data;
}

/**
 * ----------------------------------------------------------------------
 * CREATE INDENT FROM BOQ
 * POST /api/ppe/material-flow/indent/create-from-boq
 * ----------------------------------------------------------------------
 */
async function createIndentFromBOQ(
  projectId,
  orderId,
  departmentId,
  indentDate,
  indentType
) {
  const res = await axiosClient.post(
    `${BASE_URL}/create-from-boq`,
    {
      project_id: projectId,
      order_id: orderId,
      department_id: departmentId,
      indent_date: indentDate,
      indent_type: indentType,
    }
  );

  return res.data?.data;
}
/**
 * ----------------------------------------------------------------------
 * UPDATE INDENT
 * ----------------------------------------------------------------------
 */
async function updateIndent(indentId, payload) {
  const res = await axiosClient.put(
    `${BASE_URL}/${indentId}`,
    normalizeIndentPayload(payload)
  );
  return res.data?.data;
}
/**
 * ----------------------------------------------------------------------
 * ADD LINE
 * ----------------------------------------------------------------------
 */
async function addIndentLine(indentId, payload) {
  const res = await axiosClient.post(
    `${BASE_URL}/${indentId}/lines`,
    payload
  );
  return res.data?.data;
}

/**
 * ----------------------------------------------------------------------
 * UPDATE LINE
 * ----------------------------------------------------------------------
 */
async function updateIndentLine(lineId, payload) {
  const res = await axiosClient.put(
    `${BASE_URL}/lines/${lineId}`,
    payload
  );
  return res.data?.data;
}

/**
 * ----------------------------------------------------------------------
 * DELETE LINE
 * ----------------------------------------------------------------------
 */
async function deleteIndentLine(lineId) {
  const res = await axiosClient.delete(
    `${BASE_URL}/lines/${lineId}`
  );
  return res.data?.data;
}

/**
 * ----------------------------------------------------------------------
 * SUBMIT
 * ----------------------------------------------------------------------
 */
async function submitIndent(indentId) {
  const res = await axiosClient.post(
    `${BASE_URL}/${indentId}/submit`
  );
  return res.data?.data;
}

/**
 * ----------------------------------------------------------------------
 * APPROVE
 * ----------------------------------------------------------------------
 */
async function approveIndent(indentId, payload = {}) {
  const res = await axiosClient.post(
    `${BASE_URL}/${indentId}/approve`,
    payload
  );
  return res.data?.data;
}

/**
 * ----------------------------------------------------------------------
 * CLOSE
 * ----------------------------------------------------------------------
 */
async function closeIndent(indentId) {
  const res = await axiosClient.post(
    `${BASE_URL}/${indentId}/close`
  );
  return res.data?.data;
}

/**
 * ----------------------------------------------------------------------
 * EXPORT
 * ----------------------------------------------------------------------
 */
export default {
  getIndentList,
  getIndentById,
  createIndent,
  updateIndent,
  addIndentLine,
  updateIndentLine,
  deleteIndentLine,
  submitIndent,
  approveIndent,
  closeIndent,
  createIndentFromBOQ,

};
